import React from "react";
import { useNavigate } from "react-router-dom";

function StatusIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
}

function LensIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

function ApprovalIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <polyline points="9 15 11 17 15 13" />
    </svg>
  );
}

function TicketIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      {/* Topbar */}
      <header className="topbar">
        <div className="topbar-brand">
          <img src="/logo.png" alt="Wimwisure" className="topbar-logo" />
        </div>
      </header>

      {/* Main content */}
      <main className="home-page">
        <div className="home-hero">
          <img src="/logo.png" alt="Wimwisure" className="hero-logo" />
          <h1>Claim Support Portal</h1>
          <p>Access claim services, check status, and view photos — all in one place.</p>
        </div>

        <div className="services-grid">

          {/* ── Claim Status ── */}
          <div className="service-card">
            <div className="card-icon card-icon--blue">
              <StatusIcon />
            </div>
            <span className="card-badge card-badge--live">Live</span>
            <h2 className="card-title">Claim Status</h2>
            <p className="card-desc">
              Check real-time status of any claim using Case ID, Claim Number, or Vehicle Number.
            </p>
            <button className="card-btn" onClick={() => navigate("/status")}>
              Check Status →
            </button>
          </div>

          {/* ── Work Approval ── */}
          <div className="service-card">
            <div className="card-icon card-icon--orange">
              <ApprovalIcon />
            </div>
            <span className="card-badge card-badge--live">Live</span>
            <h2 className="card-title">Work Approval</h2>
            <p className="card-desc">
              Check approved parts, labour, and paint amounts for a claim's work order.
            </p>
            <button className="card-btn" onClick={() => navigate("/approval")}>
              Check Approval →
            </button>
          </div>

          {/* ── Claim Lens ── */}
          <div className="service-card">
            <div className="card-icon card-icon--green">
              <LensIcon />
            </div>
            <span className="card-badge card-badge--live">Live</span>
            <h2 className="card-title">Claim Lens</h2>
            <p className="card-desc">
              View and download claim photos organized by document type as print-ready PDFs.
            </p>
            <button className="card-btn" onClick={() => navigate("/photos")}>
              Open Claim Lens →
            </button>
          </div>

          {/* ── Support Tickets — Coming Soon ── */}
          <div className="service-card service-card--muted">
            <div className="card-icon card-icon--gray">
              <TicketIcon />
            </div>
            <span className="card-badge card-badge--soon">Coming Soon</span>
            <h2 className="card-title">Support Tickets</h2>
            <p className="card-desc">
              Submit and track support requests directly from this portal.
            </p>
            <button className="card-btn card-btn--disabled" disabled>
              Coming Soon
            </button>
          </div>

        </div>
      </main>
    </>
  );
}
